import clsx from 'clsx';
import { useEffect, useState } from 'react';
export * from './provider';

interface ToastProps {
  id: number;
  title: string;
  backgroundColor: string;
  description: string;
  customClass: string;
}

interface ToastComponentProps {
  toastList: ToastProps[];
  autoDelete?: boolean;
  autoDeleteTime?: number;
}

const Toast: React.FC<ToastComponentProps> = ({ toastList, autoDelete = true, autoDeleteTime = 3000 }) => {
  const [list, setList] = useState<ToastProps[]>(toastList);

  useEffect(() => {
    setList([...toastList]);
  }, [toastList]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && toastList.length && list.length) {
        deleteToast(toastList[0].id);
      }
    }, autoDeleteTime);

    return () => {
      clearInterval(interval);
    };

    // eslint-disable-next-line
  }, [toastList, autoDelete, autoDeleteTime, list]);

  const deleteToast = (id:number) => {
    const listItemIndex = list.findIndex((e) => e.id === id);
    const toastListItem = toastList.findIndex((e) => e.id === id);
    list.splice(listItemIndex, 1);
    toastList.splice(toastListItem, 1);
    setList([...list]);
  };

  return (
    <>
      <div className='toastClass fixed top-[100px] right-0 z-[100] '>
        {list.map((toast, i) => (
          <div
            key={i}
            className={clsx(
              toast?.customClass,
              "flex items-center p-4 mb-4 border-l-4",
            )}
            role="alert"
          >
            <svg
              className="flex-shrink-0 w-4 h-4"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <div className="ms-3 text-sm font-medium ml-3">
              {toast.description}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Toast;
